"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var useFetch_1 = require("./useFetch");
exports.default = useFetch_1.default;
__export(require("./useFetch"));
__export(require("./useMutation"));
__export(require("./useQuery"));
__export(require("./Provider"));
__export(require("./FetchContext"));
__export(require("./types"));
//# sourceMappingURL=index.js.map